import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Nav, Navbar, NavItem, NavDropdown, MenuItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "./App.css";
import "./containers/Nudge.css";
import StatusBanner from "./components/StatusBanner";
import Routes from "./Routes";
import { setUserSession, removeUserSession, getUser, hasOwnerAccess } from "./utils/Common";
import { getToken } from "./utils/Common"
import axios from "axios";
import { brandLogoWhite, brandBadge } from "./brand/theme";
// import Notification from "./components/Notification"
import { getUserMe, patchUserTZ, updateUserPWA, createCustomerPortal, getBuilder, getSharedCaps } from "./utils/bedrockAPI";

const StatusMessageDevTools = process.env.NODE_ENV === 'production'
  ? null
  : require('./dev/StatusMessageDevTools').default;

function App(props) {
  // const [isAuthenticated, userHasAuthenticated] = useState(false);
  // const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [showError, setShowError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("error-message");
  const [errorMessage, setErrorMessage] = useState("");
  const [pwaInstalled, setPWAInstalled] = useState(false);
  const [prompt, setPrompt] = useState();
  const [promptAvailable, setPromptAvailable] = useState(false);
  const [buttonSize, setButtonSize] = useState("large");
  const [pageViewsSinceNudge, setPageViewsSinceNudge] = useState(0);
  const [user, setUser] = useState(null);
  const [builder, setBuilder] = useState(null);
  const [userCaps, setUserCaps] = useState([]);
  const [hasOwnerAccessToCaps, setHasOwnerAccessToCaps] = useState(false);
  const [navAnchored, setNavAnchored] = useState(false);
  const [sessionChecked, setSessionChecked] = useState(() => !getToken());

  // The navbar is position:sticky; this just toggles the full-width
  // "anchored" styling as soon as it pins to the top of the viewport
  useEffect(() => {
    const onScroll = () => setNavAnchored(window.scrollY > 15);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    let isMounted = true;
    const token = getToken();
    if(token) {
      const config = {
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
      axios.get(
        `${process.env.REACT_APP_API_URL}/users/me`,
        config
      ).then(response => {
        if (isMounted) {
          setUserSession(token, response.data);
          setUser(response.data);
          setSessionChecked(true);
        }
      }).catch(error => { // Expired or fake token
        console.log('Token expired or invalid, redirecting to login with location:', props.location);
        removeUserSession();
        if (isMounted) {
          setSessionChecked(true);
        }
        props.history.push('/login', { from: props.location });
      });
    }
    return () => { isMounted = false; };
  }, []); // Empty dependency array means this runs once on mount

  useEffect(() => {
    let isMounted = true;
    if(window.matchMedia('(display-mode: standalone)').matches) {
      if(isMounted) {
        setPWAInstalled(true);
      }
    }

    window.addEventListener('beforeInstallPrompt', e => {
      e.preventDefault();
      // window.alert('prompted');
      if(isMounted) {
        setPrompt(e);
        setPromptAvailable(true);
      }
    });

    if(window.innerWidth<767 && isMounted) {
      setButtonSize("small");
    } 

    const timezoneOffset = (new Date()).getTimezoneOffset();
    if(timezoneOffset) {
      try {
        const u = getUser();
        if(u && u.tzOffset && u.tzOffset !== timezoneOffset) {
            patchUserTZ(u.userId,timezoneOffset);
            console.log("Updating User TZ",timezoneOffset);
        }
      } catch (e) {
        console.log("No User Credentials")
      }
    }
    
    return () => { isMounted = false; };
  },[]);

  useEffect(() => {
    let isMounted = true;
    if(isMounted) {
      setPageViewsSinceNudge(pageViewsSinceNudge+1);
    }
    if(pageViewsSinceNudge > 4) {
      if(isMounted) {
        setShowError(false);
        setErrorMessage("");
      }
    }
    return () => { isMounted = false; };
  },[props.location]);

  useEffect(() => {
    let isMounted = true;
    if(showError && isMounted) {
      setPageViewsSinceNudge(0);
    }
    return () => { isMounted = false; };
  },[showError]);

  useEffect(() => {
    let isMounted = true;
    if(promptAvailable && isMounted) {
      // if(getUser() && getUser().role==='ADMIN') { // ADMIN CONTROL - Prompting PWM
      prompt.prompt(); // 
      // }
    }
    return () => { isMounted = false; };
  },[promptAvailable])

  // This may have an issue of getting called before the user is stored.  Next page view should fix it?
  useEffect(() => {
    let isMounted = true;
    if(pwaInstalled && getUser() && isMounted) {
      updateUserPWA(getUser().userId,true);
    }
    return () => { isMounted = false; };
  },[pwaInstalled]);

  useEffect(() => {
    if(user && user.builderId) {
      getBuilder(user.builderId).then(response => {
        setBuilder(response);
      });
    }
  },[user]);

  useEffect(() => {
    async function loadUserCaps() {
      if (user && user.userId) {
        try {
          const caps = await getSharedCaps(user.userId);
          setUserCaps(caps);
          setHasOwnerAccessToCaps(hasOwnerAccess(caps));
        } catch (error) {
          console.error('Error loading user caps:', error);
          setUserCaps([]);
          setHasOwnerAccessToCaps(false);
        }
      }
    }
    loadUserCaps();
  }, [user]);

  // useEffect(() => {
  //   console.log(hasOwnerAccessToCaps,builder);
  // }, [hasOwnerAccessToCaps]);

  function handleLogout() {
    removeUserSession();
    props.history.push('/login');
  }

  function dismissStatusMessage() {
    setShowError(false);
    setErrorMessage('');
  }

  const isReserveRoute = props.location.pathname.startsWith("/reserve");

  return (
    <div>
      {showError && (
        <StatusBanner
          status={errorStatus}
          message={errorMessage}
          onDismiss={dismissStatusMessage}
        />
      )}
      <div className={`App ${isReserveRoute ? "app-container-reserve" : "app-container"}`}>
        {!isReserveRoute && (
        <Navbar fluid collapseOnSelect className={`brand-navbar ${navAnchored ? "navbar-anchored" : ""}`}>
          <Navbar.Header>
            <Navbar.Brand>
              {getToken()!=null
              ? <Link to={"/dashboard"}><img src={brandLogoWhite} alt="Bedrock Wireless" /></Link>
              : <Link to="/"><img src={brandLogoWhite} alt="Bedrock Wireless" /></Link>
              }
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight>
              {getToken()!=null 
              ? <React.Fragment>
                  {getUser().role!=="PAYMENTS" && (
                    <LinkContainer to={"/dashboard"}>
                      <NavItem>Dashboard</NavItem>
                    </LinkContainer>
                  )}
                  {getUser().role==="ADMIN" && (
                    <LinkContainer to="/admin">
                      <NavItem>Admin</NavItem>
                    </LinkContainer>
                  )}
                  {getUser().role!=="PAYMENTS" && (
                    <LinkContainer to="/help">
                      <NavItem>Help</NavItem>
                    </LinkContainer>
                  )}
                  {/* {getUser().role==="ADMIN" && ( */}
                  {/* Admin dropdown - Access Control only for ADMIN/BILLING, Camera Management for ADMIN/BILLING or OWNER access */}
                  {((getUser().builderStatus === 'ADMIN' || getUser().builderStatus === 'BILLING') || hasOwnerAccessToCaps) && getUser().builderId && getUser().role!=='ADMIN' && ( 
                    <NavDropdown title="Admin" id="admin-nav-dropdown">
                      {(getUser().builderStatus === 'ADMIN' || getUser().builderStatus === 'BILLING') && (
                        <LinkContainer to={`/accesscontrol/${getUser().builderId || ""}`}>
                          <NavItem>Access Control</NavItem>
                        </LinkContainer>
                      )}
                      <LinkContainer to={`/cameramanagement/${getUser().builderId || ""}`}>
                        <NavItem>Camera Management</NavItem>
                      </LinkContainer>
                      {builder && builder.stripeId && (getUser().builderStatus === 'ADMIN' || getUser().builderStatus === 'BILLING') &&(
                        <NavItem onClick={async () => {
                          try {
                            const response = await createCustomerPortal(getUser().userId);
                            window.open(response.url, '_blank');
                          } catch (error) {
                            console.error('Error opening billing portal:', error);
                          }
                        }}>
                          Billing Dashboard
                        </NavItem>
                      )}
                    </NavDropdown>
                  )}
                  {getUser().role!=="PAYMENTS" && (
                    <NavDropdown title="My Account" id="collapsible-nav-dropdown">
                      <LinkContainer to="/account/info">
                        <NavItem>Account Info</NavItem>
                      </LinkContainer>
                      <LinkContainer to="/account/notifications">
                        <NavItem>Notifications</NavItem>
                      </LinkContainer>
                      <LinkContainer to="/account/password">
                        <NavItem>Change Password</NavItem>
                      </LinkContainer>
                      <LinkContainer to="/account/integrations">
                        <NavItem>Integrations</NavItem>
                      </LinkContainer>
                      {(getUser().role==="ADMIN" || getUser().role==="LABELER") && (
                        <LinkContainer to="/labels">
                          <NavItem>Labels</NavItem>
                        </LinkContainer>
                      )}
                      <NavItem onClick={handleLogout}>
                        Logout
                      </NavItem>
                      {buttonSize==="small" && (<MenuItem divider />)}
                    </NavDropdown>
                  )}
                  {getUser().role==="PAYMENTS" && (
                    <NavItem onClick={handleLogout}>
                      Logout
                    </NavItem>
                  )}
                </React.Fragment>
              : <React.Fragment>
                <LinkContainer to="/signup">
                  <NavItem>Sign Up</NavItem>
                </LinkContainer>
                <LinkContainer to="/login">
                  <NavItem>Login</NavItem>
                </LinkContainer>
                </React.Fragment>
              }
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        )}
        {sessionChecked && (
          <Routes appProps={{ 
            showError, 
            setShowError, 
            errorMessage, 
            setErrorMessage, 
            errorStatus, 
            setErrorStatus,
            handleLogout
          }} />
        )}
       <footer className="brand-footer">
          <img src={brandBadge} alt="Bedrock Wireless" />
        </footer>
      </div>
      {StatusMessageDevTools && user?.role === 'ADMIN' && (
        <StatusMessageDevTools
          setShowError={setShowError}
          setErrorMessage={setErrorMessage}
          setErrorStatus={setErrorStatus}
        />
      )}
    </div>
  );
}

export default withRouter(App);
